"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _default = (0, _propTypes.shape)({
  color: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),
  fontSize: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),
  fontWeight: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),
  justifyContent: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),
  letterSpacing: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),
  lineHeight: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),
  mb: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),
  textAlign: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string])
});

exports["default"] = _default;